import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=b4c37f54&scoped=true"
import script from "./PaySuccess.vue?vue&type=script&lang=js"
export * from "./PaySuccess.vue?vue&type=script&lang=js"
import style0 from "./PaySuccess.vue?vue&type=style&index=0&id=b4c37f54&prod&lang=css"
import style1 from "./PaySuccess.vue?vue&type=style&index=1&id=b4c37f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c37f54",
  null
  
)

export default component.exports